import { useForm } from 'react-hook-form';
import { ComponentProps } from 'lib/component-props';
import { GetStaticComponentProps, constants } from '@sitecore-jss/sitecore-jss-nextjs';
import { getAllStates } from 'src/GraphQL/queries/stateList.query';
import { getAllTimeZones } from 'src/GraphQL/queries/timeZoneList.query';
import { debounce } from '@mui/material/utils';
import ContactInfoContextProvider from '../ContactInfoContextProvider';
import { ContactInfoFieldsInterface } from '../ContactInfo.types';
import { useStoreContactInfoData } from '../useStoreContactInfoData';
import { formatCaregiverFormData, formatDOB } from '../../../transformers/contactInfo.transform';
import { updateContactInfo } from 'src/features/contactInfoSlice';
import useContactInfoHelper from 'src/lib/hooks/useContactInfoHelper';
import {
  callDapApiSendEmail,
  constructVirtualSiteData,
  prePopulateSceeenerDataCaregiverForm,
  updateConsents,
  validateSMSandIsMobile,
  prepopulateMyProfileForCaregiverForm,
} from '../helper';
import { getDefaultTimeZone } from '../../../lib/utils/timeZoneHelpers';
import { useRouter } from 'next/router';
import { ExtenedLayoutServiceContextInterface } from '../../../lib/type/Site';
import { useEffect, useRef, useState } from 'react';
import * as cdpService from '../../../services/CdpService';
import { CDP_EVENTS, EMAIL_TEMPLATES, JOURNEYS, SITE_SOURCE } from '../../../constants';
import {
  fetchProfileDetailsForCR,
  prePopulateEprContactDetails,
  savePatientDelegateDetailsToCDP,
} from '../../../lib/utils/axiosCDPFetcher';
import {
  ENROLLMENT_EXPIRY_TIME_FALLBACK,
  getCookie,
  getCookieExpiryTime,
  getOrCreateEnrollmentId,
} from '../../../lib/utils/enrollmentUtil';
import { JOURNEY_STEP } from '../../../constants';
import { fetchNextPossiblePathAndData } from '../../../services/CdpService';
import { storeCDPData } from '../../../features/cdpDataSlice';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import getBaseURL from '../../../lib/utils/getBaseURL';
import { LifeLinkRequest } from '../../../types/LifeLink';
import { updateLLDetailsTODB, postToLifeLink, post } from '../../../lib/utils/axiosFetcher';
import getQueryParamsAsString from '../../../lib/utils/getQueryParamsAsString';
import { getQuery, getRespectiveCOIList, removeTrailingSlash } from '../../../lib/utils/common';
import { deleteCookie, setCookie } from 'cookies-next';
import { checkReturningUser } from '../../../services/ReturningUserService';
import { addpotentialParticipantId } from '../../../features/potentialParticipantDetailsSlice';
import { PatientType } from '../../../lib/type/userJourney.types';
import { useMutation } from 'react-query';
import { trackEvent } from '../../../lib/utils/gtmService';
import isEmpty from 'lodash/isEmpty';
import { fetchConditionOfInterest } from '../../../GraphQL/queries/fetchConditionOfInterest.query';
import { setAuthentication } from '../../../features/authSlice';
import { setProfileData } from '../../../features/crProfileSlice';
import {
  getCommunities,
  getStringValFromArray,
  getStringValFromArrayForCDP,
} from '../../../services/RegisterUserService';
import dynamic from 'next/dynamic';
import axios from 'axios';
import { DataOrigin, updateUCPMJobRecordsForCR } from '../../../lib/utils/ucpmHelper';

const ContactInfo = dynamic(() => import('../ContactInfo'), {
  ssr: false,
});

export type ContactListProps = ComponentProps & ContactInfoFieldsInterface;

const CaregiverContactInfo = (props: ContactListProps): JSX.Element => {
  const {
    dispatch,
    executeRecaptcha,
    selectedLanguage,
    potentialParticipant_ID,
    potentialId,
    isRecapchaEnabled,
    timeZoneList,
    screenerOutput,
    prepopulateConfig,
    reCaptchItem,
    autoCompleteLocationInfo,
    geolocation,
    cdpState,
    siteSettingsId,
    setCustomErrorModal,
    showCustomErrorModal,
    setPatientExistModal,
    showPatientExistErrorModal,
    returningUserTimeInterval,
    returningUserTimeValue,
    setEmailSentModal,
    showEmailSentModal,
    ContactNumberField,
    ConsentsMedium,
  } = useContactInfoHelper(props);

  const router = useRouter();
  const { query } = router;

  const { sitecoreContext } = useSitecoreContext();
  const siteSettings: any = sitecoreContext?.siteSettings;
  const tenantKey = siteSettings?.tenantKey?.value || '';
  const journeyType = useSelector((state: RootState) => state?.cdpData?.journeyType);
  const cdpData = useSelector((state: RootState) => state?.cdpData);
  const isEnableGoogleRecaptcha = siteSettings?.EnableGoogleRecaptcha?.value || false;
  const selectedPlace = useSelector((state: RootState) => state.selectedSite);
  const sitecoreFieldsForContactInfo = useSelector(
    (state: RootState) => state.contactInfoDetails.sitecoreFieldsForContactInfo
  );
  const selectedCOIList = useSelector(
    (state: RootState) => state.registrationDetails.selectedCOIList
  );
  const updatePpidRef = useRef<any>(false);
  const retuningUser = useRef<any | null>(null);
  const mailIdList = siteSettings?.sendMailingList?.value || '';
  const emailType = EMAIL_TEMPLATES.REGISTRATION_WELCOME;
  const baseUrl = siteSettings?.baseUrl?.value || '';
  const cleanBaseUrl = removeTrailingSlash(baseUrl);
  const myProfileEndpoint = siteSettings?.myProfileItemUrl?.value?.href || '/manage-my-profile';
  const myProfileUrl = `${cleanBaseUrl}${myProfileEndpoint}`;
  const source = siteSettings?.source?.fields?.name?.value;
  const [myProfileData, setMyProfileData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const isAuthenticated: boolean = useSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );

  const getFormDataDefaultValue = (existingValues: any) => {
    if (myProfileData) {
      return {
        UserTimeZone: getDefaultTimeZone(timeZoneList, existingValues),
        ...prePopulateSceeenerDataCaregiverForm(
          screenerOutput,
          prepopulateConfig,
          existingValues,
          geolocation,
          sitecoreFieldsForContactInfo,
          cdpData
        ),
        ...prepopulateMyProfileForCaregiverForm(myProfileData),
      };
    } else {
      return {
        UserTimeZone: getDefaultTimeZone(timeZoneList, existingValues),
        ...prePopulateSceeenerDataCaregiverForm(
          screenerOutput,
          prepopulateConfig,
          existingValues,
          geolocation,
          sitecoreFieldsForContactInfo,
          cdpData
        ),
      };
    }
  };

  const updateCurrentJourneyStepinCDP = async () => {
    const payload = {
      enrollmentId: getOrCreateEnrollmentId(),
      journeyStep: JOURNEY_STEP.CONTACT_INFO,
      journeyStatus: cdpState?.journeyStatus,
      isActiveEnrollment: '1',
    };

    if (potentialParticipant_ID) {
      const guestType = cdpState?.guestType || 'visitor';
      cdpService.updateCurrentJourneyInCDP(potentialParticipant_ID, guestType, payload);
    }
  };

  const prepopulateMyProfile = async () => {
    const authenticatedUserToken = sessionStorage.getItem('myProfileVerificationToken');
    if (authenticatedUserToken && isAuthenticated) {
      const response = await prePopulateEprContactDetails(authenticatedUserToken, tenantKey);
      if (response.data) {
        setMyProfileData(response.data);
      }
    }
  };

  const formHandlerObject = useForm({
    mode: 'all',
    defaultValues: async () => getFormDataDefaultValue({}),
  });

  const { watch, trigger, setError } = formHandlerObject;
  const FieldsToCheckForReturningUser = [
    'CaregiverEmail',
    'ParticipantFirstName',
    'ParticipantLastName',
    'Day',
    'Month',
    'Year',
  ];

  useEffect(() => {
    updateCurrentJourneyStepinCDP();
    prepopulateMyProfile();
    trackEvent({
      event: 'Participant Type identified',
      participantType: PatientType.CAREGIVER,
    });
  }, []);

  useEffect(() => {
    const existingValues = formHandlerObject?.getValues();
    formHandlerObject.reset({ ...existingValues, ...getFormDataDefaultValue(existingValues) });
  }, [prepopulateConfig, sitecoreFieldsForContactInfo, myProfileData]);

  useEffect(() => {
    const debouncedCb = debounce(async (value: any, { name }) => {
      if (FieldsToCheckForReturningUser.includes(name)) {
        const allValuesAvailable = FieldsToCheckForReturningUser.every((field: string) => {
          if (name === 'Day' || name === 'Month' || name === 'Year') {
            return (
              (value['Year'] !== '' && value['Year'] !== null && value['Year'] !== undefined) ||
              (value['Month'] !== '' && value['Month'] !== null && value['Month'] !== undefined) ||
              (value['Day'] !== '' && value['Day'] !== null && value['Day'] !== undefined)
            );
          } else {
            return value[field] !== '' && value[field] !== null && value[field] !== undefined;
          }
        });
        if (allValuesAvailable !== undefined && allValuesAvailable) {
          const isValid = await trigger(FieldsToCheckForReturningUser as never[]);
          if (isValid) {
            await populateExistingUserConsents(
              value['CaregiverEmail'],
              value['ParticipantFirstName'],
              value['ParticipantLastName'],
              value['Day'],
              value['Month'],
              value['Year']
            );
          }
        }
      }
    }, 3000);

    const subscription = watch((v, n) => {
      debouncedCb(v, n);
      if (ConsentsMedium.length > 0) {
        validateSMSandIsMobile(v, trigger, setError, ContactNumberField);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const updatePotentialParticipantId = async () => {
    try {
      const { data: response } = await post(
        `/Participant/UpdatePotentialParticipantId?potentialId=${potentialId}&potentialParticipantId=${getCookie(
          'bx_guest_ref'
        )}`
      );
      return response;
    } catch (_e: any) {}
  };

  const { mutate: updatePpId } = useMutation(
    'update-potential-participantId',
    updatePotentialParticipantId,
    {
      onSuccess: (_data) => {
        return _data;
      },
      onError: () => undefined,
    }
  );

  const updateUCPMJobRecords = async (isUserRegistered = false) => {
    try {
      const { data } = await axios.get(`/api/cr-context-data`);
      const siteSettings = data?.siteSettings;
      if ((siteSettings as any)?.enableUCPMIntegration?.value === false) {
        return;
      }
      return await updateUCPMJobRecordsForCR({
        otSponsorId: siteSettings?.otSponsorId?.value || '',
        otPurposeId: siteSettings?.otPurposeId?.value || '',
        sponsor: siteSettings?.sponsorName?.value || '',
        iqviaSponsorId: siteSettings?.iqviaSponsorId?.value || '',
        dataOrigin: isUserRegistered ? DataOrigin.TA_CR_UPDATE : DataOrigin.TA_CR_REGISTRATION,
        UCPMStudyName: siteSettings?.UCPMStudyName?.value || '',
        baseUrl: siteSettings?.baseUrl?.value || '',
      });
    } catch (_e) {}
  };

  const successCallback = async ({ data }: any) => {
    const extensionData = {
      ContactFormSubmit: true,
    };
    setIsLoading(false);
    cdpService.event(CDP_EVENTS.CONTACT_FORM_SUBMIT, extensionData);
    const { getValues } = formHandlerObject;
    const email = getValues('CaregiverEmail' as never);
    cdpService.identityEvent(email);
    dispatch(updateContactInfo(data));

    const successCallbackData = data;
    try {
      //TODO: Journey status and enrollment id should be part of query params
      const formData = getValues();
      const payloadData = formatCaregiverFormData(
        formData,
        selectedLanguage,
        getCookie('bx_guest_ref'),
        potentialId,
        autoCompleteLocationInfo,
        tenantKey,
        getOrCreateEnrollmentId(),
        cdpState?.patientReferralStatus,
        selectedPlace
      );

      if (!isEmpty(selectedCOIList)) {
        const communityList = getCommunities(selectedCOIList);
        const communities = getStringValFromArrayForCDP(communityList, 'value', 'key');
        (payloadData as any)['communities'] = communities;

        (payloadData as any)['conditionOfInterest'] = getRespectiveCOIList(selectedCOIList, true);
      }

      const enrollmentId = getOrCreateEnrollmentId();
      const cdpPayload = {
        ...payloadData,
        journeyStatusRequest: {
          enrollmentId: enrollmentId,
          journeyStep: JOURNEY_STEP.CONTACT_INFO,
          journeyStatus: '',
        },
      };
      // update existing record in db
      if (updatePpidRef.current) {
        updatePpId();
      }
      if (siteSettings?.source?.fields?.name?.value === 'CR') {
        const authenticatedUserToken = sessionStorage.getItem('myProfileVerificationToken');
        const isUserRegistered = authenticatedUserToken && isAuthenticated ? true : false;
        updateUCPMJobRecords(isUserRegistered);
      }
      //post data to cdp on contact form submission, so cdp can take decision on next possible path
      setIsLoading(true);
      const data = await savePatientDelegateDetailsToCDP(
        `/api/contacts/AddUpdatePatientDetails/${getCookie('bx_guest_ref')}?guestType=${
          cdpState?.guestType || 'customer'
        }`,
        cdpPayload,
        siteSettings?.source?.fields?.name?.value
      );
      setIsLoading(false);
      if (data && siteSettings?.source?.fields?.name?.value === 'CR') {
        dispatch(setAuthentication(true));
      }

      if (
        !!retuningUser?.current &&
        source === SITE_SOURCE &&
        retuningUser?.current?.sendCrRegistrationEmail !== 'No'
      ) {
        const payload = {
          email,
          mailIdList,
          emailType,
          baseUrl,
          myProfileUrl,
          resendAttemptCount: 0,
          siteSettingsId: sitecoreContext?.siteSettingsId as any,
          language: sitecoreContext?.language as any,
          enrollmentId: getOrCreateEnrollmentId(),
        };
        setIsLoading(true);
        await callDapApiSendEmail(payload);
        setIsLoading(false);
      }
      const myProfileVerificationToken = sessionStorage.getItem('myProfileVerificationToken');

      if (myProfileVerificationToken) {
        try {
          const { data } = await fetchProfileDetailsForCR(myProfileVerificationToken);
          if (data) {
            dispatch(setProfileData(data));
          }
        } catch (_e) {}
      }
      //Exp api call to get next possible path
      try {
        //TODO: Need to change experience api one done from backend side, currently using old exp api
        const experienceId = process.env.NEXT_PUBLIC_CDP_EXPERIENCE_CONTACTINFO_ID;
        setIsLoading(true);
        const data = await fetchNextPossiblePathAndData(
          experienceId,
          false,
          false,
          sitecoreContext?.site?.name
        );
        setIsLoading(false);
        if (journeyType === JOURNEYS.JOURNEY_02 && data?.isVirtual) {
          await cdpService.updateIsVirtualinCDP(
            getCookie('bx_guest_ref'),
            cdpState?.guestType || 'visitor', // TODO: Confirm if it is Visitor or customer
            data.isHumanAPIEnabledForVirtual,
            data?.sitesData,
            potentialId,
            potentialParticipant_ID,
            successCallbackData.patientId
          );

          const constructedSitesData = constructVirtualSiteData(
            data,
            tenantKey,
            enrollmentId,
            potentialId,
            potentialParticipant_ID,
            successCallbackData
          );

          const response = await post(
            '/SiteSelection/AddOrUpdatePatientSiteDetails',
            constructedSitesData
          );
          if (!response) {
            throw new Error('Error in updating Virtual Sites Data');
          }
        }
        const getPostToLLPayload = (): LifeLinkRequest => {
          const siteSettingsId: any = sitecoreContext?.siteSettingsId;
          const language: any = sitecoreContext?.language || 'en';
          return {
            tenantKey: siteSettings?.tenantKey?.value || '',
            enrollmentId: getOrCreateEnrollmentId(),
            lifeLinkEnabled: '1',
            subjectHighRisk: screenerOutput.r || '',
            baseURL: getBaseURL(),
            queryParams: getQueryParamsAsString(),
            sitecode: selectedPlace?.siteInfo?.siteCode || '',
            protocol: selectedPlace?.siteInfo?.protocol || '',
            languageName: language,
            siteSettingsId: siteSettingsId || '',
            isLLBackgroundJobCall: false,
            PotentialId: potentialId,
          };
        };

        const goToNextStep = async () => {
          let appointmentStatus = data?.appointmentStatus;
          if (!appointmentStatus) {
            appointmentStatus = 'NotInitiated';
          }
          if (journeyType === JOURNEYS.JOURNEY_01 && selectedPlace?.siteInfo?.isLifeLinkEnabled) {
            const patientId = successCallbackData.patientId || '';
            if (!data?.isPostTOLL) {
              await updateLLDetailsTODB(
                getOrCreateEnrollmentId(),
                tenantKey,
                appointmentStatus,
                potentialId,
                patientId
              );
            }
          }
          if (data?.nextStepUrl) {
            //TODO: this line need to remove once exp api is fully functional
            setCookie('journeyStep', JOURNEY_STEP.CONTACT_INFO, {
              expires: getCookieExpiryTime(
                siteSettings?.resumeEnrollmentExpirationDays?.value ||
                  ENROLLMENT_EXPIRY_TIME_FALLBACK
              ),
              secure: true,
            });
            if (journeyType === JOURNEYS.JOURNEY_03) {
              trackEvent({
                event: 'Completed Contact Form',
              });
            }
            // await router.push(data?.nextStepUrl);
            await router.push(
              {
                pathname: data?.nextStepUrl,
                query: getQuery(query),
              },
              data?.nextStepUrl
            );
          }
        };
        dispatch(storeCDPData(data));
        if (data?.isPostTOLL) {
          const payload = getPostToLLPayload();
          try {
            const dapApiLLResponse = await postToLifeLink(payload);
            if (dapApiLLResponse.lifeLinkUrl) {
              window.location.href = dapApiLLResponse.lifeLinkUrl;
            } else {
              if (data?.nextStepUrl) {
                await goToNextStep();
              }
            }
          } catch (e: any) {
            if (data?.nextStepUrl) {
              await goToNextStep();
            }
          }
        } else if (data?.nextStepUrl) {
          await goToNextStep();
        }
      } catch (_e) {
        //TODO: need to check if exp api fails what need to be done
        setIsLoading(false);
      }
    } catch (_e: any) {
      //TODO: need to check if CDP api fails
      setIsLoading(false);
    }
  };
  const failureCallback = () => {
    setIsLoading(false);
    const extensionData = {
      ContactFormSubmit: false,
      tenantKey: tenantKey,
      journeyType: journeyType as string,
    };
    cdpService.event(CDP_EVENTS.CONTACT_FORM_ERROR, extensionData);
  };

  const { mutate } = useStoreContactInfoData(successCallback, failureCallback);

  const saveDataToDBAndCdp = async (data: any) => {
    let token: string | null = null;
    if (isEnableGoogleRecaptcha || isRecapchaEnabled) {
      if (!executeRecaptcha) {
        return false;
      }
      token = await executeRecaptcha('caregiver_form');
    }
    const contactInfoData = formatCaregiverFormData(
      data,
      selectedLanguage,
      getCookie('bx_guest_ref'),
      potentialId,
      autoCompleteLocationInfo,
      tenantKey,
      getOrCreateEnrollmentId(),
      cdpState?.patientReferralStatus,
      selectedPlace
    );
    const payload = {
      ...contactInfoData,
      token,
      contactFormSettingsId: reCaptchItem?.id,
      siteSettingsId,
    };
    if (!isEmpty(selectedCOIList)) {
      const communityList = getCommunities(selectedCOIList);
      const communities = getStringValFromArray(communityList, 'value', 'key');
      (payload as any)['communities'] = communities;
      (payload as any)['conditionOfInterest'] = getRespectiveCOIList(selectedCOIList);
    }
    dispatch(updateContactInfo(payload));
    setIsLoading(true);
    mutate({ url: '/Delegate/Add', payload });
    return;
  };

  const populateExistingUserConsents = async (
    email: string,
    participantFirstName: string,
    participantLastName: string,
    participantDateOfBirthDay: string,
    participantDateOfBirthMonth: string,
    participantDateOfBirthYear: string
  ) => {
    try {
      const participantDateOfBirth = formatDOB(
        participantDateOfBirthDay,
        participantDateOfBirthMonth,
        participantDateOfBirthYear
      );

      const { data: res } = await checkReturningUser(
        false,
        tenantKey,
        PatientType.CAREGIVER,
        email,
        returningUserTimeInterval,
        returningUserTimeValue,
        participantFirstName,
        participantLastName,
        participantDateOfBirth,
        false,
        true,
        sitecoreContext?.site?.name
      );
      retuningUser.current = res;

      if (res?.secondaryconsent?.combinedConsentAccepted === 'True') {
        if (Object.keys(res?.secondaryconsent).length) {
          updateConsents('combined', res?.secondaryconsent);
        }
      } else {
        if (Object.keys(res?.primaryconsent).length) {
          updateConsents('primary', res?.primaryconsent);
        }
        if (Object.keys(res?.secondaryconsent).length) {
          updateConsents('secondary', res?.secondaryconsent);
        }
      }
    } catch (_e) {
      retuningUser.current = null;
      return;
    }
  };

  const performReturningUserCheckOnSubmit = async (
    data: any,
    isResumeEmailCheck: boolean,
    isReturnCheck: boolean,
    isJourney3: boolean
  ) => {
    try {
      const email = data['CaregiverEmail'];
      const participantFirstName = data['ParticipantFirstName'];
      const participantLastName = data['ParticipantLastName'];
      const participantDateOfBirth = formatDOB(data['Day'], data['Month'], data['Year']);
      setIsLoading(true);
      const { data: res } = await checkReturningUser(
        true,
        tenantKey,
        PatientType.CAREGIVER,
        email,
        returningUserTimeInterval,
        returningUserTimeValue,
        participantFirstName,
        participantLastName,
        participantDateOfBirth,
        isResumeEmailCheck,
        isReturnCheck,
        sitecoreContext?.site?.name,
        isJourney3
      );
      setIsLoading(false);
      retuningUser.current = res;

      //setting this cookie so in outcome pages we can de-activate that enrollment
      if (res?.deActivateExistingEnrollment) {
        setCookie('shouldDeactivateExistingEnrollment', res?.deActivateExistingEnrollment, {
          expires: getCookieExpiryTime(
            siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
          ),
          secure: true,
        });
      } else {
        //delete the cookie immediately
        const expireAfterTwoSecond = new Date();
        expireAfterTwoSecond.setTime(expireAfterTwoSecond.getTime() + 1);
        deleteCookie('shouldDeactivateExistingEnrollment', {
          expires: expireAfterTwoSecond,
          secure: true,
        });
      }

      if (res?.showResumeEmailModal === true) {
        setEmailSentModal();
        showEmailSentModal();
      } else if (res?.isReturningUser === false) {
        if (res?.potentialParticipantId) {
          setCookie('bx_guest_ref', res?.potentialParticipantId, {
            expires: getCookieExpiryTime(
              siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
            ),
            secure: true,
          });
          dispatch(addpotentialParticipantId(res?.potentialParticipantId));
          updatePpidRef.current = true;
        }
        if (res?.browserId) {
          const cookieName = 'bid_' + process.env.NEXT_PUBLIC_CDP_CLIENT_KEY;
          setCookie(cookieName, res?.browserId, {
            secure: true,
            expires: getCookieExpiryTime(
              siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
            ),
          });
        }
        await saveDataToDBAndCdp(data);
      } else {
        if (res?.showCustomErrorMessageModel) {
          // show modal popup
          setCustomErrorModal();
          showCustomErrorModal();
        } else if (res?.showPatientExistModel) {
          // show modal popup
          setPatientExistModal();
          showPatientExistErrorModal();
        }
        return;
      }
    } catch (_e) {
      return;
    }
  };

  const onSubmit = async (data: any) => {
    // check for returning user before submitting information
    let isResumeEmailCheck = false;
    let isReturnCheck = false;
    let isJourney3 = false;
    if (journeyType === JOURNEYS.JOURNEY_03) {
      isResumeEmailCheck = !siteSettings?.disableResumeJourney?.value ? true : false;
      isJourney3 = true;
    }
    if (journeyType === JOURNEYS.JOURNEY_02) {
      isResumeEmailCheck = !siteSettings?.disableResumeJourney?.value ? true : false;
      isReturnCheck = true;
    }
    if (journeyType === JOURNEYS.JOURNEY_01) {
      isResumeEmailCheck = false;
      isReturnCheck = true;
    }
    performReturningUserCheckOnSubmit(data, isResumeEmailCheck, isReturnCheck, isJourney3);
  };

  return (
    <ContactInfoContextProvider formHandlerObject={formHandlerObject}>
      <ContactInfo onSubmit={onSubmit} fields={props?.fields} isLoading={isLoading} />
    </ContactInfoContextProvider>
  );
};

export const getStaticProps: GetStaticComponentProps = async (_rendering, layoutData) => {
  //TODO: Need to check if we can have this as commom code, can be used for other contact forms
  const context = layoutData?.sitecore?.context as ExtenedLayoutServiceContextInterface;
  const language = context?.language || process.env.DEFAULT_LANGUAGE || 'en';
  const countryId = context?.siteSettings?.country?.id as string;

  if (process.env.JSS_MODE === constants.JSS_MODE.DISCONNECTED) {
    return null;
  }

  const stateList = await getAllStates(language, countryId);
  const timeZoneList = await getAllTimeZones(language, countryId);
  const COIList = await fetchConditionOfInterest(language);

  return {
    stateList,
    timeZoneList,
    COIList,
  };
};
export default CaregiverContactInfo;
